import React from "react";
import {
    Typography,
    Avatar,
    makeStyles,
    Card,
} from "@material-ui/core";
import UserInfo from "../../model/userInfo";


const useStyles = makeStyles(() => ({
    avatar: {
        width: "130px",
        height: "130px",
        marginTop: "40%",
        marginLeft: "20px",
        marginRight: "20px",
    },
    centerHorizontal: {
        marginLeft: "auto",
        marginRight: "auto",
    },
    flex1: {
        flexGrow: 1,
    },
    centerText: {
        textAlign: "center",
    },
}));

type AcceptOpponentScreenProps = {
    user: UserInfo;
}

export default function DefinedOpponent({ user }: AcceptOpponentScreenProps): JSX.Element {
    const classes = useStyles();

    return (
        <Card elevation={0} className={`${classes.centerHorizontal} ${classes.flex1}`}>
            <Avatar
                alt={user.name}
                src={user.image}
                className={`${classes.centerHorizontal} ${classes.avatar}`}
            />
            <Typography variant="h3" className={`${classes.centerHorizontal} ${classes.centerText}`}>
                {user.name}
            </Typography>
            <Typography variant="h5" className={`${classes.centerHorizontal} ${classes.centerText}`}>
                {user.username}
            </Typography>
        </Card>
    );
}
